import React from "react";
import { useCollection } from "../hooks/useCollection";

import fallback1 from "../assets/img/portfolio/portfolio-1.jpg";
import fallback2 from "../assets/img/portfolio/portfolio-3.jpg";
import fallback3 from "../assets/img/portfolio/portfolio-6.jpg";

const fallbackImgs = [fallback1, fallback2, fallback3];

const News = () => {
  const { items, loading } = useCollection("news", "order", "asc");

  return (
    <section id="news" className="news py-5">
      <div className="section-title text-center" data-aos="fade-up">
        <h2>News</h2>
        <p>ข้อมูลข่าวสารและกิจกรรมอัพเดท</p>
      </div>
      <div className="container">
        {loading ? (
          <div className="text-center text-muted py-4">กำลังโหลดข่าวสาร...</div>
        ) : items.length === 0 ? (
          <div className="text-center text-muted py-4">
            ยังไม่มีข่าวสาร
          </div>
        ) : (
          <div className="row g-4">
            {items.map((item, idx) => (
              <div className="col-md-4" key={item.id}>
                <div className="card h-100 shadow-sm">
                  <img
                    className="card-img-top"
                    src={item.imageUrl || fallbackImgs[idx % fallbackImgs.length]}
                    alt={item.title}
                    style={{ height: 220, objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{item.title}</h5>
                    {item.summary && (
                      <p className="card-text">{item.summary}</p>
                    )}
                    <span className="card-buttons">
                      {item.link && (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noreferrer"
                          className="ready-btn read-news-btn"
                        >
                          อ่านข่าวนี้
                        </a>
                      )}
                      <a href="/news" className="ready-btn all-news-btn">
                        ข่าวทั้งหมด
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default News;
